import { onUnmounted } from 'vue';

import { debug } from '@silae/helpers';

const LIGHT = 'light';
const DARK = 'dark';
const FAVICON_HREF_BASE = 'favicon-theme-';

export function useFavicon() {
	const setFaviconTheme = (theme: 'light' | 'dark') => {
		document.getElementById('ce-favicon').setAttribute('href', `/${FAVICON_HREF_BASE}${theme}.png`);
		debug('favicon theme', theme);
	};
	const updateFaviconTheme = (e: MediaQueryListEvent) => {
		const isDefaultDark = !!e?.matches;
		const theme = isDefaultDark ? DARK : LIGHT;
		setFaviconTheme(theme);
	};

	const prefersDarkMedia = window?.matchMedia?.('(prefers-color-scheme: dark)');
	prefersDarkMedia?.addEventListener('change', updateFaviconTheme);
	setFaviconTheme(!!prefersDarkMedia?.matches ? DARK : LIGHT);

	onUnmounted(() => {
		prefersDarkMedia.removeEventListener('change', updateFaviconTheme);
	});
}
